import { Box, Flex, FlexProps, Text, Tooltip } from '@chakra-ui/react'

import { formatDateTimeWithAt } from '@/utils/formatDateTime'

const Separator = () => (
  <Box backgroundColor='#2D2E41' height='0.85em' mx={3} width='1px' />
)

interface NotificationSubtitleIProps extends FlexProps {
  timestamp: string
  sourceName?: string
  facilityShortName?: string
  facilityName?: string
  fontSize?: number | string
}

export const NotificationSubtitle = ({
  timestamp,
  sourceName,
  facilityShortName,
  facilityName,
  fontSize = '12px',
  ...rest
}: NotificationSubtitleIProps) => {
  return (
    <Flex
      alignItems='center'
      color='#2D2E41'
      data-testid='NotificationSubtitle:details'
      direction='row'
      fontSize={fontSize}
      fontWeight='bold'
      letterSpacing='-0.33px'
      maxW='300px'
      opacity='0.8'
      w='full'
      {...rest}
    >
      <Flex maxW='40%' noOfLines={1}>
        {formatDateTimeWithAt(timestamp)}
      </Flex>
      {sourceName && (
        <Flex alignItems='center' maxW='45%'>
          <Separator />
          <Text noOfLines={1}>{sourceName}</Text>
        </Flex>
      )}
      {facilityShortName && (
        <Flex alignItems='center'>
          <Separator />
          <Tooltip label={facilityName} shouldWrapChildren>
            <Text noOfLines={1}>{facilityShortName}</Text>
          </Tooltip>
        </Flex>
      )}
    </Flex>
  )
}
